<template>
  <modal name="modal-add-usertype" height="auto" :width="400"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD USER TYPE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="form-group">
          <label for="title">Title <span class="text-danger">*</span></label>
          <input type="text" name="title" id="title" ref="inputTitle"
                 :class="{'form-control': true, 'is-invalid': errors.has('title')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.title">
          <div class="invalid-feedback">{{ errors.first('title') }}</div>
        </div>
        <div class="form-group">
          <label for="color_class">Color</label>
          <select name="color_class" id="color_class"
                  :class="['form-control']" v-model="postData.color_class">
            <option class="text-white bg-secondary" value="">Default</option>
            <option class="text-white bg-primary" value="primary">Blue</option>
            <option class="text-white bg-success" value="success">Green</option>
            <option class="text-white bg-info" value="info">Cyan</option>
            <option class="text-white bg-warning" value="warning">Yellow</option>
            <option class="text-white bg-danger" value="danger">Red</option>
          </select>
        </div>

        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'

import ServiceUserType from '@/services/usertype'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: '',
      postData: false,
    }
  },
  props: ['value'],
  computed: mapState({
  }),
  watch: {
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.$modal.show('modal-add-usertype', {});
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.resetForm();
    },
    resetForm () {
      let self = this;
      self.postData = {
        title: '',
        color_class: '',
      };
    },
    closeModal () {
      this.$modal.hide('modal-add-usertype');
    },
    doCreate ( ) {
      let self = this;

      if (self.state == 'saving') {
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            ServiceUserType.create(self.postData, userType => {
              self.state = '';
              self.$notify({
                type: 'success',
                text: 'User type <strong>' + userType.title + '</strong> added'
              });
              self.resetForm();
              self.$emit('usertype-added', userType);
              self.closeModal();
            }, () => {
              self.state = '';
            });
          }
        });
    }
  }
}
</script>
